'use strict';
var search = require('base/search/search');
var swatchBag = require('friartux/components/swatch');
var a11y = require('friartux/components/accessibility');
const { CLASSES, CONFIG } = require('../utils/globals');

const SELECTORS = {
    body: 'body',
    gridFooter: '.js-grid-footer',
    modalBackground: '.modal-background',
    refinementBar: '.refinement-bar',
    pageBreadcrumb: '.js-page-breadcrumb',
    stickypPageBreadcrumb: '.js-sticky-page-breadcrumb',
    imageLinkDisabled: '.js-image-link.disabled',
    miniPLPContainer: '.js-mini-plp-container',
    refinementCloseBtn: '.js-close-refinement',
    swatchRefineColorBtn: '.js-refinement-btn-color',
    activeSwatchRefineColorBtn: '.js-refinement-btn-color.active',
    swatchRefineRentOrBuy: '.js-refinement-btn-isrentorbuy',
    activeSwatchRefineRentOrBuy: '.js-refinement-btn-isrentorbuy.selected',
    productGridCol: '.product-grid-col',
    swatchPage: '.swatch-page',
    swatchBag: '.swatch-bag',
    swatchProductTile: '.swatch-page .product',
    footer: 'footer',
    fastrWrapper: '.has-fastr',
    couponPromoDetailsBtn: '.js-coupon-promo-details-btn',
    couponPromoDetails: '.js-coupon-promo-details',
    couponPromoDetailsModalContent: '.js-promo-details-modal-content',
    appliedCouponsWrapper: '.js-applied-coupons-wrapper',
    appliedCoupons: '.js-applied-coupons',
    manageCouponBtn: '.js-manage-coupons',
    refineByCount: '.js-refine-by-count',
    refinementWithSelection: '.js-refinement-has-selection'
};

let windowWidth = $(window).innerWidth();
let hasFastr = $(SELECTORS.fastrWrapper).length > 0;

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {

    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var className = '.' + $(this)[0].className;
        var classData = className.replace(/[^a-zA-Z0-9]/g, '').replace(/ /g, '.');
        var activeDiv = $results.find(classData);
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
    search.initObserver();
}

/**
 * Restore keyboard focus to the refinement value the user just toggled, after
 * the refinements panel has been re-rendered via Ajax. Falls back to the
 * section's accordion title button when the value is no longer focusable.
 *
 * @param {string} panelId - id of the .refinement-content panel
 * @param {number} btnIndex - index of the toggled button within the panel
 * @return {undefined}
 */
function restoreRefinementFocus(panelId, btnIndex) {
    if (!panelId || btnIndex < 0) {
        return;
    }
    var $panel = $('#' + panelId);
    var $btn = $panel.find('.refinement-btn').eq(btnIndex);
    if ($btn.length && !$btn.is(':disabled')) {
        $btn.focus();
    } else {
        $panel.closest('.refinement').find('button.title').first().focus();
    }
}

/**
 * Expand the refinement sections that contain applied filters
 *
 * @return {undefined}
 */
function expandSelectedRefinements() {
    $(SELECTORS.refinementWithSelection).each(function () {
        var $refinement = $(this);
        $refinement.add($refinement.find('.collapsible-xs')).addClass(CLASSES.active);
        $refinement.find('button.title').attr('aria-expanded', 'true');
    });
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.search-result-count',
        '.js-availability-refinements',
        SELECTORS.refineByCount
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });

    var countText = $('.search-result-count').text().trim();
    if (countText) {
        a11y.announceToSR(countText);
    }
}

function sliderEvents(from,to) {
    var currentUrl = window.location.origin + $('#refinement-price .values.content li button:first').data('href');
    var url = new URL(currentUrl);
    if(currentUrl.indexOf('undefined') > -1) {
        url = $('meta[property="og:url"]').prop('content');
        url = new URL(url);
    }
    url.searchParams.set("pmin", encodeURIComponent(from));
    url.searchParams.set("pmax", encodeURIComponent(to));
    var newUrl = url.href;
    newUrl = newUrl.replace(window.location.origin, "");
    // console.log(newUrl);

    $(this).trigger('search:filter');
    $.ajax({
        url: newUrl,
        data: {
            page: $('.grid-footer').data('page-number'),
            selectedUrl: newUrl
        },
        method: 'GET',
        success: function (response) {
            parseResults(response);
            $('.slider-box .range-container .from').html('From: $' + from);
            $('.slider-box .range-container .to').html('To: $'+ to);
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Loads more products on scroll
 * @return {undefined}
 */
function loadMoreProducts(showMoreUrl) {
    const data = { selectedUrl: showMoreUrl };
    const isCartPage = $('.look-builder').length > 0;
    $('.lazy-load-intersect').removeClass('lazy-load-intersect');
    if (!hasFastr) {
        $(SELECTORS.footer).hide();
    }

    $.ajax({
        url: showMoreUrl,
        data,
        dataType: 'html',
        method: 'GET',
        success:  function (response) {
            if (!isCartPage && !hasFastr) {
                $(SELECTORS.footer).show();
            }
            var $response = $(response);
            $('.js-grid-footer').replaceWith($response);
            updateUrl(response);
            search.initObserver();
            a11y.announceToSR($('.search-result-count').text().trim());
        },
        error: function () {
            if (!isCartPage && !hasFastr) {
                $(SELECTORS.footer).show();
            }
        }
    });
}

/**
 * Updates the URL with Permalink
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateUrl(response) {
    let $results = $(response);
    try {
        let permalink = $results.find('.permalink');
        if (permalink && permalink.val() && !($(SELECTORS.miniPLPContainer).length > 0)) {
            window.history.replaceState(null, '', permalink.val());
        }
    } catch (error) {
        // console.log('permalink not set');
    }
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    let $tempDom = $('<div>').append($(response));
    let sortOptions = $tempDom.find(SELECTORS.gridFooter).data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Hangle sticky refinements bar
 * @return {void}
 */
function handleStickyRefinements() {
    $(window).on('scroll', function() {
        let scroll = $(window).scrollTop();

        if (scroll >= 150 && windowWidth > CONFIG.breakpointDesktop) {
            $(SELECTORS.refinementBar).addClass(CLASSES.sticky);
            $(SELECTORS.stickypPageBreadcrumb).addClass(CLASSES.active);
        } else {
            $(SELECTORS.refinementBar).removeClass(CLASSES.sticky);
            $(SELECTORS.stickypPageBreadcrumb).removeClass(CLASSES.active);
        }
    });
}

function handleIntersect(entries, observer) {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            let $target = document.querySelector('.lazy-load-intersect');
            observer.unobserve($target);

            setTimeout(function () {
                const $loadMoreButton = $('.js-show-more-products');
                if ($loadMoreButton.length) {
                    $(this).trigger('search:showMore');
                    loadMoreProducts($loadMoreButton.data('url'));
                }
            }, SitePreferences.PDP_LAZY_LOAD_SPEED);
        }
    });
}

function showActiveSwatchTiles() {
    var $gridCols = $(SELECTORS.productGridCol);
    $gridCols.removeClass('active').hide();

    var rentOrBuySelectors = [];
    var activeSelectors = [];

    $(SELECTORS.activeSwatchRefineRentOrBuy).each(function (_, element) {
        var value = String($(element).data('value'));
        var values = value.split('|');

        values.forEach(function (val) {
            rentOrBuySelectors.push('.js-poption-' + val);
        });
    });

    var hasColorFilter = $(SELECTORS.swatchRefineColorBtn).hasClass('active');
    if (hasColorFilter) {
        $(SELECTORS.activeSwatchRefineColorBtn).each(function (_, element) {
            var color = $(element).data('color-value');

            if (rentOrBuySelectors.length) {
                rentOrBuySelectors.forEach(function (rbSelector) {
                    activeSelectors.push(
                        rbSelector + '.js-product-' + color
                    );
                });
            } else {
                activeSelectors.push('.js-product-' + color);
            }
        });
    } else {
        activeSelectors = rentOrBuySelectors;
    }

    if (activeSelectors.length) {
        activeSelectors.forEach(function (selector) {
            $(selector)
                .closest(SELECTORS.productGridCol)
                .addClass('active')
                .show();
        });
    } else {
        $gridCols.show();
    }
}

search.applyFilter = function () {
    // Handle refinement value selection and reset click
    $('.container').on(
        'click',
        '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .js-availability-refinements li button',
        function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $clicked = $(this);
            // Capture the toggled refinement so focus can be restored after the
            // refinements panel is re-rendered (WCAG 2.4.3 Focus Order).
            var $panel = $clicked.closest('.refinement-content');
            var panelId = $panel.attr('id');
            var btnIndex = panelId ? $panel.find('.refinement-btn').index($clicked) : -1;

            $clicked.trigger('search:filter', e);
            $.ajax({
                url: $clicked.data('href'),
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: $clicked.data('href')
                },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    updateUrl(response);
                    updateSortOptions(response);
                    restoreRefinementFocus(panelId, btnIndex);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
};

search.filter = function () {
    // Display refinements bar when Menu icon clicked
    $('.container').on('click', 'button.filter-results', function (e) {
        e.stopPropagation();
        $(this).toggleClass(CLASSES.active).attr('aria-expanded', 'true');
        $(SELECTORS.refinementBar).toggleClass(CLASSES.active);

        $('.refinement-bar, .modal-background').addClass(CLASSES.active).show();
        $(SELECTORS.refinementBar).siblings().attr('aria-hidden', true);
        $(SELECTORS.refinementBar).closest('.row').siblings().attr('aria-hidden', true);
        $(SELECTORS.refinementBar).closest('.tab-pane.active').siblings().attr('aria-hidden', true);
        $(SELECTORS.refinementBar).closest('.container.search-results').siblings().attr('aria-hidden', true);
        expandSelectedRefinements();
        $('.refinement-bar .close').focus();
    });
};

search.closeRefinements = function () {
    // Refinements close button
    $(SELECTORS.body).on('click', function (e) {
        if (!$('.refinement-bar, .modal-background').hasClass(CLASSES.active)) {
            return;
        }

        if (!$(e.target).closest(SELECTORS.refinementBar).length &&
            !$(e.target).is(SELECTORS.refinementBar) ||
            $(e.target).is(SELECTORS.refinementCloseBtn)) {
                $(this).removeClass(CLASSES.active);
                $(SELECTORS.refinementBar).removeClass(CLASSES.active);

                $('.refinement-bar, .modal-background').removeClass(CLASSES.active).hide();
                $(SELECTORS.refinementBar).siblings().attr('aria-hidden', false);
                $(SELECTORS.refinementBar).closest('.row').siblings().attr('aria-hidden', false);
                $(SELECTORS.refinementBar).closest('.tab-pane.active').siblings().attr('aria-hidden', false);
                $(SELECTORS.refinementBar).closest('.container.search-results').siblings().attr('aria-hidden', false);
                var $filterBtn = $('.btn.filter-results');
                $filterBtn.attr('aria-expanded', 'false').focus();
        }
    });
};

search.resize = function () {
    // Close refinement bar and hide modal background if user resizes browser
    $(window).on('resize', function () {
        windowWidth = $(window).innerWidth();
        $(SELECTORS.refinementBar).removeClass('active');
        $('button.filter-results').removeClass('active');

        // Close the expanded refinements
        if ($(window).width() < 992) {
            $('.refinement').removeClass("active");
        }
    });
};

search.initObserver = function (target) {
    let $target = document.querySelector('.lazy-load-intersect');

    if (target) {
        $target = target;
    }

    if ($target) {
        let observer = new IntersectionObserver(handleIntersect, {
            threshold: 0.5
        });
        observer.observe($target);
    }
}

search.priceSlider = function () {
    $("#price-range").slider({
        step: 20,
        range: true,
        min: 0,
        max: 500,
        values: [0, 500],
        slide: function(event, ui) {
            var from = ui.values[0]
            var to = ui.values[1]

            sliderEvents(from,to);
        }
    });
};

search.sort = function () {
    // Handle sort order menu selection
    $('.container').on('change', '[name=sort-order]', function (e) {
        e.preventDefault();

        $(this).trigger('search:sort', this.value);
        $.ajax({
            url: this.value,
            data: { selectedUrl: this.value },
            method: 'GET',
            success: function (response) {
                $('.product-grid').empty().html(response);
                updateUrl(response);
                search.initObserver();
                a11y.announceToSR($('.search-result-count').text().trim());
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

search.disableProduct = function () {
    $(SELECTORS.body).on('click', SELECTORS.imageLinkDisabled, (e) => {
        e.preventDefault();
    })
};

search.handleStickyRefinements = handleStickyRefinements;

// Do not expand the refinement on mobile by default. Remove the code below to
// auto-expand the Hide/Show filter on mobile as well.
search.removeActiveFilter = function () {
    if ($(window).width() < 992) {
        $('.refinement').removeClass("active");
    }
}

search.initSwatch = function() {
    swatchBag.init();

    $(SELECTORS.swatchRefineColorBtn).on('click', function() {
        $(this).toggleClass('active');
        $(this).attr('aria-checked', $(this).hasClass('active') ? 'true' : 'false');
        showActiveSwatchTiles();
    });

    $(SELECTORS.swatchRefineRentOrBuy).on('click', function() {
        if ($(this).hasClass('selected') &&
            $(SELECTORS.activeSwatchRefineRentOrBuy).length <= 1) {
                return;
        }

        $(this).toggleClass('selected');
        $(this).attr('aria-checked', $(this).hasClass('selected') ? 'true' : 'false');
        showActiveSwatchTiles();
    })

    if ($(SELECTORS.swatchPage).length > 0) {
        $(SELECTORS.footer).hide();
        $(SELECTORS.swatchPage).css('padding-bottom', $(SELECTORS.swatchBag).height());
    }

    $(SELECTORS.swatchProductTile).on({
        'click': function() {
            $(this).addClass('expand');
        },
        'mouseenter': function() {
            $(this).addClass('expand');
        },
        'mouseleave': function() {
            $(this).removeClass('expand');
        }
    });

    var isMobile = ('ontouchstart' in document.documentElement && /mobi/i.test(navigator.userAgent));
    if (isMobile) {
        $(SELECTORS.swatchProductTile).off('mouseenter');
    }

}

// Refresh product grid
search.initPromocode = function() {
    $(SELECTORS.body).on('promotion:success', function(e, promoData) {
        updatePlpGrid(promoData);
    });

    $(SELECTORS.body).on('promotion:remove', function(e, promoData) {
        updatePlpGrid(promoData);
    });

    $(SELECTORS.body).on('click', SELECTORS.couponPromoDetailsBtn, function() {
        $(SELECTORS.couponPromoDetailsModalContent).html($(this).siblings(SELECTORS.couponPromoDetails).html());
    });

    function updatePlpGrid(promoData) {
        let plpUrl = new URL($('.js-show-more-products').data('url') || $('.js-grid-footer').data('show-all-product-url'));
        plpUrl.searchParams.set('start', 0);
        $.ajax({
            url: plpUrl.toString(),
            dataType: 'html',
            method: 'GET',
            cache: false,
            success:  function (response) {
                var $response = $(response);
                $('.product-grid').html($response);
                search.initObserver();
            }
        });

        const seeDetailsLabel = $(SELECTORS.manageCouponBtn).data('see-details-label');
        const applyPromoLabel = $(SELECTORS.manageCouponBtn).data('apply-promo-label');
        $(SELECTORS.appliedCoupons).empty();
        if (promoData.totals.hasCouponDiscount) {
            $('.js-coupons-and-promos').empty().append(promoData.totals.discountsWithDetails);
            $(SELECTORS.appliedCouponsWrapper).removeClass(CLASSES.hide);
            const discounts = promoData.totals.discounts;
            discounts.forEach((discount) => {
                if (discount.type === 'coupon') {
                    let discountHtml = $('<span/>').addClass('b-coupon-price-adjustment');
                    discountHtml.append('<strong/>').html(discount.couponCode);
                    $(SELECTORS.appliedCoupons).append(discountHtml);
                }
            });

            $(SELECTORS.manageCouponBtn).text(seeDetailsLabel);
        } else {
            $(SELECTORS.appliedCouponsWrapper).addClass(CLASSES.hide);
            $(SELECTORS.manageCouponBtn).text(applyPromoLabel);
        }
    }
}

module.exports = search;
